(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hanataba-hybrid-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hanataba-hybrid-banner')) {
    customElements.define('hanataba-hybrid-banner', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        this.template = this.querySelector('[data-desktop-video]');
        if (!this.template) return;
        this.videoSlot = this.querySelector('.htb-hybrid__video-slot');
        this.toggle = this.querySelector('[data-video-toggle]');
        this.desktop = matchMedia('(min-width: 768px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.userPaused = false;
        this.allowMotion = false;
        this.update = () => this.sync();
        this.motionChanged = () => { this.allowMotion = false; this.sync(); };
        this.onToggle = () => {
          if (this.video && !this.video.paused) {
            this.userPaused = true;
          } else {
            this.userPaused = false;
            this.allowMotion = true;
          }
          this.sync();
        };
        this.desktop.addEventListener('change', this.update);
        this.reducedMotion.addEventListener('change', this.motionChanged);
        document.addEventListener('visibilitychange', this.update);
        this.toggle.addEventListener('click', this.onToggle);
        this.updateControl(false);
        this.toggle.hidden = false;
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        });
        this.observer.observe(this);
      }

      sync() {
        if (!this.desktop.matches) {
          this.releaseVideo();
          return;
        }
        const shouldPlay = this.visible && !document.hidden && !this.userPaused
          && (!this.reducedMotion.matches || this.allowMotion);
        if (!shouldPlay) {
          if (this.video) this.video.pause();
          return;
        }
        if (!this.video) {
          // The inert template is never mounted on mobile: no video source can load.
          this.videoSlot.append(this.template.content.cloneNode(true));
          this.video = this.videoSlot.querySelector('video');
          this.video.muted = true;
          this.video.addEventListener('playing', () => {
            this.setAttribute('data-playing', '');
            this.updateControl(true);
          });
          this.video.addEventListener('pause', () => {
            this.updateControl(false);
          });
          this.video.addEventListener('error', () => {
            this.removeAttribute('data-playing');
            this.updateControl(false);
          });
        }
        this.video.play().catch(() => {
          // Autoplay may be blocked. Keep the poster and offer a manual play button.
          if (this.toggle && (!this.video || this.video.paused)) this.updateControl(false);
        });
      }

      updateControl(playing) {
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pause : this.toggle.dataset.play);
        this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', playing);
        this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', !playing);
      }

      releaseVideo() {
        if (!this.video) return;
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.remove());
        this.video.load();
        this.videoSlot.replaceChildren();
        this.video = null;
        this.removeAttribute('data-playing');
        this.updateControl(false);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.desktop?.removeEventListener('change', this.update);
        this.reducedMotion?.removeEventListener('change', this.motionChanged);
        if (this.update) document.removeEventListener('visibilitychange', this.update);
        this.toggle?.removeEventListener('click', this.onToggle);
        this.releaseVideo();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
